<template>
  <div class="checkin">
    <br />
    <DatiCheckIn :reservation="reservation" />
    <br />
  </div>
</template>

<script>
import DatiCheckIn from "@/components/DatiCheckIn.vue";
import router from "@/router/index";
import store from "@/store/index";
const axios = require("axios");

export default {
  name: "CheckIn",
  data() {
    return {
      invio_in_corso: false,
    };
  },
  props: {
    reservation: Object,
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },

  components: {
    DatiCheckIn,
  },
  beforeRouteEnter(to, from, next) {
    try {
      let canale = "";
      let origine = "";
      let reservation_code = "";

      let ServerURL = store.state.ServerURL;

      switch (to.name) {
        case "BackOfficeOrigine":
          canale = "BackOffice";
          origine = to.params.origine;
          reservation_code = to.query.reservationcode;
          break;

        case "OnlineOrigine":
          canale = "Online";
          origine = to.params.origine;
          reservation_code = to.query.reservationcode;
          break;

        default:
          router.push("/home/linknonvalido");
          return;
      }

      if (reservation_code == undefined || reservation_code == "") {
        router.push("/home/linknonvalido");
        return;
      }

      document.querySelector("body").style.cursor = "wait";

      axios({
        method: "get",
        url:
          ServerURL +
          "?canale=" +
          canale +
          "&origine=" +
          origine +
          "&reservationcode=" +
          reservation_code,
        responseType: "text",
      }).then(function (response) {
        document.querySelector("body").style.cursor = "default";
        if (response.data.errore == 0) {
          to.params.reservation = response.data.oggetto;
          to.params.nome_file_logo = response.data.oggetto.nome_file_logo;

          if (canale == "BackOffice") {
            store.commit(
              "SettaLingua",
              response.data.oggetto.select_struttura.lingua
            );
          } else {
            store.commit(
              "SettaLingua",
              response.data.oggetto.reservation.lingua
            );
          }

          next();
        } else if (response.data.errore == -2) {
          router.push({
            name: "Errore",
            params: { errore: response.data.esito },
          });
        } else {
          if (
            response.data.esito == "prenotazione_non_trovata" ||
            response.data.esito == "struttura_non_confermata"
          ) {
            router.push({
              name: "CheckInNonAttivato",
              params: {
                reservation_code: reservation_code,
              },
            });
          } else if (
            response.data.esito == "struttura_non_trovata" ||
            response.data.esito == "struttura_non_attiva" ||
            response.data.esito == "prenotazione_errata"
          ) {
            router.push("/home/linknonvalido");
          } else {
            router.push({
              name: "Errore",
              params: { errore: response.data.esito },
            });
          }
        }
      });
    } catch (error) {
      document.querySelector("body").style.cursor = "default";

      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {};
    let labels_inglese = {};
    let labels_tedesco = {};
    let labels_francese = {};

    let labels_errori_italiano = {};
    let labels_errori_inglese = {};
    let labels_errori_tedesco = {};
    let labels_errori_francese = {};

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "CheckIn-fn_CambiaLingua");
  }
}
</script>

<style></style>
